import React, { Component } from "react";
import "../static/style/checkout.css"


class PaymentCard extends Component {
    constructor (props) {
        super(props);
    }
    parameterToInput = (param, index) =>
    {
        return <input type='hidden' name={param.name} value={param.value} key={index}/>
    }
    render () {
        return (
        <form method='POST' action={this.props.provider.url}>
            {this.props.provider.parameters.map(this.parameterToInput)}
            <button className="payment-card-btn"><img className="payment-card-img" src={this.props.provider.svg}/></button>
        </form>
        )
    }
}

export default PaymentCard;


// WEBPACK FOOTER //
// ./src/components/PaymentCard.js